module.exports = __webpack_public_path__ + "static/media/thumb.39ada9ab.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/projects/willow-walk-remodelling/thumb.jpg
// module id = 50
// module chunks = 0